export default {
  PRODUCT_OWNER: 1,
  SCRUM_MASTER: 2,
  RELEASE_TRAIN_ENGINEER: 3
};


// WEBPACK FOOTER //
// ./src/components/utils/ContactType.js